import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { generatePath } from 'react-router-dom'
import { Button, Label } from 'views/components'
import { uiEvents } from 'modules/ui/state'
import { ROUTES } from 'constants/routes'
import { $TSFixMe } from 'types/ts-migrate'
import styles from '../Beneficiary.module.scss'

type TProps = {
  /** Party whose contact page the "Add now" button links to. Hidden when absent. */
  partyId?: string | null
}

/**
 * Shared "No bank account saved" indicator with an inline "Add now" shortcut to
 * the contact's edit page. Used by both Beneficiary and DepositBeneficiary so the
 * messaging and the add-bank-details flow stay consistent.
 */
const NoBankDetails: React.FC<TProps> = ({ partyId }): React.ReactElement => {
  const dispatch = useDispatch()
  const pathname = useSelector((state: $TSFixMe) => state.router.location.pathname)
  const isAdhocInvoiceRoute = pathname === ROUTES.adhocInvoice

  const goToEditContact = (id: string): void => {
    dispatch(uiEvents.redirect(generatePath(ROUTES.editContact, { id })))
  }

  return (
    <span className={styles['no-bank-details']}>
      <Label circular className={styles['no-bank-details-label']}>
        No bank account saved
      </Label>
      {!isAdhocInvoiceRoute && partyId && (
        <Button
          className={styles['add-bank-details-button']}
          pill
          ghost
          size="xs"
          onClick={() => goToEditContact(partyId)}
        >
          Add now
        </Button>
      )}
    </span>
  )
}

export default NoBankDetails
